export default function AccessControl(store, api, router) {
    this.store = store;
    this.api = api;
    this.router = router;

    this.setUser = function (user) {
        this.store.dispatch('accessControl/setUser', { user: user });
    };

    this.refresh = async function () {
        var vm = this;

        try {
            var resp = await vm.api.Auth.profile();
            var data = resp.data.data;

            vm.setUser(data);
        } catch (err) {
            // vm.$flash.error(err.response.data.message);
        }
    };

    this.user = function () {
        return this.store.state.accessControl.user;
    };

    this.hasAccessStore = function (store_id) {
        var store = this.store.state.accessControl.user.store;

        return Array.isArray(store) &&
            store.map(String).includes(String(store_id));
    };

    this.hasAccessBranch = function (branch_id) {
        var branch = this.store.state.accessControl.user.branch;

        return Array.isArray(branch) &&
            branch.map(String).includes(String(branch_id));
    };

    this.hasAccess = function (name) {
        var permissions = this.store.state.accessControl.user.permission;

        if (Array.isArray(permissions))
            return permissions.includes(name);

        return false;
    };

    this.hasAccesses = function (list) {
        return Array.isArray(list) && list.some((item) => this.hasAccess(item));
    };
}